import React from 'react';
import { Link } from 'react-scroll';

export const Faq = () => {
	return (
		<main role="main" className="view h-auto">
			<h1 className="sr-only visually-hidden">Assist@: Faqs</h1>
			<div className="container-fluid container-hd faqs-layout px-sm">
				<aside className="faqs-aside">
					<h1 className="sr-only visually-hidden">Faqs: Sidebar</h1>
					<ul className="list-unstyled mb-0 py-3 pt-md-1 sticky-top">
						<li className="mb-xs lh-copy">
							<Link className="text-uppercase font-weight-bold ls-n1 fs-3" activeClass="o-100 text-secondary" role="button" spy={true} hashSpy={true} smooth={true} offset={-100} duration={150} to="header">
								FAQ
							</Link>
						</li>
						<hr className="mt-0" />
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="PASSWORD">
								J’ai oublié mon mot de passe. Que faire ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="DOSSIER">
								Lors de l'appel avec l’ayant droit, où je trouve le dossier ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="PLUSIEURS-LOGEMENTS">
								Le défunt était propriétaire de plusieurs logements, où est-ce que je dois les ajouter ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="GRATUIT">
								Le défunt était logé à titre gratuit ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="ACTIVITES">
								Le défunt avait plusieurs activités professionnelles ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="DEMARCHES-COMMUNES">
								Dans les démarches communes, il y a des organismes avec lesquels le défunt n’était pas en lien
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="DEMARCHES-PERSONNALISEES">
								Dans les démarches personnalisées, il y a un organisme avec lequel le défunt était en lien que je ne trouve pas ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="HANDICAP">
								Le défunt était en situation de handicap ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="SERVICE">
								J’ai sélectionné un service mais je n’ai pas la référence ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="ADRESSE">
								Je n’ai pas l’adresse dans la liste proposée ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="CONTRATS">
								Le défunt possédait plusieurs contrats au sein du même organisme que faire ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="NOTAIRE">
								Pourquoi un notaire ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="MOBILE">
								Téléphone mobile et box internet la différence ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="VEHICULE">
								Assurance véhicule ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="COURRIERS">
								Je n’arrive pas à accéder aux courriers alors que j’ai fini de compléter le dossier.
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="ENFANTS">
								Le défunt avait des enfants, où est-ce que je dois les mentionner ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="CAISSES-RETRAITE">
								Le défunt est rattaché à plusieurs caisses de retraite ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="AIDES">
								Je ne sais pas quelles aides demander ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="REVERSIONS">
								Pourquoi dois-je choisir les réversions ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="DELAIS">
								Les courriers sont générés, mais je ne connais pas les délais à respecter pour l’envoi.
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="ORGANISMES">
								Je ne trouve pas le courrier du service/organisme sélectionné.
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="MODIFICATION">
								Peut-on modifier les informations après la génération des courriers ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="CREER-DOSSIER">
								Comment créer un dossier dans l’espace bibliothèque ayant droit?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="TELECHARGER">
								Comment télécharger les documents de la bibliothèque de documents ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="PARTAGER">
								Peut-on partager un document ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="CONTACT">
								Vous ne trouvez pas la réponse à votre question ?
							</Link>
						</li>
					</ul>
				</aside>
				<section className="faqs-main pb-lg" id="detailPrivacy">
					<header className="block" id="header">
						<div className="display-4 font-weight-bold ls-n1">FAQ</div>
						<p className="text-muted lh-copy mb-0">
							Version à jour au <span className="text-underline text-dark"> 24/05/2024 </span>
						</p>
						<hr className="mb-0" />
					</header>
					<article className="block pb-5" id="PASSWORD">
						<h2 className="text-uppercase font-weight-demi mt-4">J’ai oublié mon mot de passe. Que faire ?</h2>
						<p className="mb-0">Si vous avez perdu votre mot de passe, ne vous inquiétez pas ! Il vous suffit de cliquer sur 'Mot de passe oublié' sur la page de connexion. Suivez ensuite les instructions pour réinitialiser votre mot de passe et accéder à votre compte en toute sécurité.</p>
					</article>
					<article className="block pb-5" id="DOSSIER">
						<h2 className="text-uppercase font-weight-demi">Lors de l'appel avec l’ayant droit, où je trouve le dossier ?</h2>
						<p className="mb-0">Celui-ci vous est accessible dans votre espace partenaire en cliquant sur l'icône dossier est “accéder au dossier”.</p>
					</article>
					<article className="block pb-5" id="PLUSIEURS-LOGEMENTS">
						<h2 className="text-uppercase font-weight-demi">Le défunt était propriétaire de plusieurs logements, où est-ce que je dois les ajouter ?</h2>
						<p className="mb-2">Vous devez uniquement noter la résidence principale du défunt.</p>
						<p className="mb-0">Par contre, s’il avait plusieurs contrats (EDF, gaz…) vous pouvez ajouter toutes les références de ses contrats.</p>
					</article>
					<article className="block pb-5" id="GRATUIT">
						<h2 className="text-uppercase font-weight-demi">Le défunt était logé à titre gratuit ?</h2>
						<p className="mb-0">Cochez “autre" dans type de bien et sélectionnez le bien correspondant. Une personne ne peut avoir qu’une résidence principale.</p>
					</article>
					<article className="block pb-5" id="ACTIVITES">
						<h2 className="text-uppercase font-weight-demi">Le défunt avait plusieurs activités professionnelles ?</h2>
						<p className="mb-0">Vous pouvez sélectionner plusieurs situations : exemple : retraité et activité ; retraité et autres activités (trésorier, tuteur, ….)</p>
					</article>
					<article className="block pb-5" id="DEMARCHES-COMMUNES">
						<h2 className="text-uppercase font-weight-demi mt-4">Dans les démarches communes, il y a des organismes avec lesquels le défunt n’était pas en lien</h2>
						<p>Les démarches communes correspondent aux organismes avec lesquels 90% des français sont en lien, c’est pour cela que les cases sont pré-sélectionnées.</p>
						<p className="mb-0">Vous pouvez les dé-sélectionner si nécessaire.</p>
					</article>
					<article className="block pb-5" id="DEMARCHES-PERSONNALISEES">
						<h2 className="text-uppercase font-weight-demi mt-4">Dans les démarches personnalisées, il y a un organisme avec lequel le défunt était en lien que je ne trouve pas ? </h2>
						<p className="mb-0">
							Vous pouvez sélectionner dans <b>“autres abonnements et adhésions</b> et allocations”, vous pourrez noter le type de service, la référence, l’adresse ce qui vous permettra d’avoir les courriers de résiliation ou modification. Exemple: Leasing voiture, syndicats, panier bio, box beauté, abonnement
							croquettes…
						</p>
					</article>
					<article className="block pb-5" id="HANDICAP">
						<h2 className="text-uppercase font-weight-demi mt-4">Le défunt était en situation de handicap ? </h2>
						<p className="mb-2">
							Vous pouvez sélectionner dans “autres abonnements, adhésions et <b>allocations</b>”, la MDPH, MDA ou MDMPH à laquelle il était rattaché car ils peuvent varier selon les pays ou les régions
						</p>
						<p className="mb-0 small">MDPH: maison départementale des personnes handicapées</p>
						<p className="mb-0 small">MDA : Maison départementale de l’autonomie ( MDPH + service departementale grand âge)</p>
						<p className="mb-0 small">MDMPH: Maison départementale et métropolitaine des personne handicapées</p>
						<p className="mb-2 small">MDPSH: Maison départementale des personnes en situations de handicap.</p>
						<p className="mb-2 text-warning">AVANT la complétude du dossier, vérifiez que les informations de l’ayant droit sont correctes.</p>
						<p className="mb-0">
							Pour valider les informations, cliquez sur “mandataires” afin de les corriger pour que celles-ci soient à jour <b>avant</b> la création de tous les courriers car après cela ne sera plus modifiable.
						</p>
					</article>
					<article className="block pb-lg" id="SERVICE">
						<h2 className="text-uppercase font-weight-demi mt-4">J’ai sélectionné un service mais je n’ai pas la référence ?</h2>
						<p className="mb-0">Pas de panique, c’est mieux de l'avoir mais vous pouvez mettre le nom et prénom du défunt en référence ou ajouter le service en favori en cochant l’étoile pour reprendre plus tard.</p>
					</article>
					<article className="block pb-lg" id="ADRESSE">
						<h2 className="text-uppercase font-weight-demi mt-4">Je n’ai pas l’adresse dans la liste proposée ?</h2>
						<p className="mb-0">Assist@ vous permet d’ajouter plusieurs banques mais il y a toujours une banque principale (versement salaire, retraite, aide…). Compléter la banque principale puis valider et apparaît un bouton bleu “ ajouter une autre banque”. Vous pouvez en ajouter autant que nécessaire.</p>
					</article>
					<article className="block pb-lg" id="CONTRATS">
						<h2 className="text-uppercase font-weight-demi mt-4">Le défunt possédait plusieurs contrats au sein du même organisme que faire ?</h2>
						<p className="mb-0">
							S'il dispose de plusieurs contrats pour un même sujet (assurance habitation, abonnement eau / gaz, etc ), cliquez alors sur “ajouter une autre référence” sur le menu de l’organisme choisi (ce qui créera plusieurs courriers que vous pourrez modifier ou résilier) ou mettez-les à la suite{" "}
							<b>avec un point virgule</b> entre chaque référence si vous souhaitez la même option (modification ou résiliation) pour tous les contrats.
						</p>
					</article>
					<article className="block pb-lg" id="NOTAIRE">
						<h2 className="text-uppercase font-weight-demi mt-4">Pourquoi un notaire ?</h2>
						<p className="mb-2">Le choix du notaire permet de le mentionner sur tous les courriers afin de traiter et faciliter la gestion administrative de la succession.</p>
						<p className="mb-2">
							<b>Il est obligatoire</b> s' il y a des biens immobiliers, si testament, si il y a des dettes, si règlement judiciaire et quand le <b>montant de la succession est égal ou supérieur à 5000 €</b> (acte de notoriété).
						</p>
						<p className="mb-0">Si le notaire n’est pas noté au moment du choix des services, les informations et demandes seront transmises à l’ayant droit figurant sur les courriers</p>
					</article>
					<article className="block pb-lg" id="MOBILE">
						<h2 className="text-uppercase font-weight-demi mt-4">Téléphone mobile et box internet la différence ?</h2>
						<p className="mb-2">Le téléphone portable et fixe peuvent faire partie d'une offre globalisée. Il faut faire attention de ne pas résilier la box internet s' il y a des services comme “alarme maison”.</p>
						<p className="mb-2">Si vous souhaitez résilier uniquement le forfait mobile, vous pouvez le faire via le service téléphone mobile.</p>
						<p className="mb-0">Faites attention car en résiliant l’offre internet vous pouvez généralement résilier le téléphone fixe, portable et internet si le défunt avait une offre groupée.</p>
					</article>
					<article className="block pb-lg" id="VEHICULE">
						<h2 className="text-uppercase font-weight-demi mt-4">Assurance véhicule ?</h2>
						<p className="mb-2">
							L’assurance du véhicule peut être <b>résiliée</b> uniquement si <b>le véhicule n’est plus utilisé</b>, jusqu'à la future vente ou la répartition des biens de la succession (nouvelle assuré).
						</p>
						<p className="mb-0">Tout véhicule utilisé doit être assuré.</p>
					</article>
					<article className="block pb-lg" id="COURRIERS">
						<h2 className="text-uppercase font-weight-demi mt-4">Je n’arrive pas à accéder aux courriers alors que j’ai fini de compléter le dossier. </h2>
						<p className="mb-0">
							Vous accédez aux courriers UNIQUEMENT si les services sélectionnés sont complétés avec les références ou <b>ajoutés en favori</b> avec <b>l’étoile</b>.
						</p>
					</article>
					<article className="block pb-lg" id="ENFANTS">
						<h2 className="text-uppercase font-weight-demi mt-4">Le défunt avait des enfants, où est-ce que je dois les mentionner ?</h2>
						<p className="mb-0">Au moment de la validation des informations au jour du décès, vous devez revalider toutes les informations du défunt et ajouter la date de naissance de chaque enfant dans l’onglet “environnement familial et privé”.</p>
					</article>
					<article className="block pb-lg" id="CAISSES-RETRAITE">
						<h2 className="text-uppercase font-weight-demi mt-4">Le défunt est rattaché à plusieurs caisses de retraite ? </h2>
						<p className="mb-2">Si le défunt travaille ou a travaillé sur des activités dépendant des caisses de retraites suivantes:</p>
						<ul className="pl-sm">
							<li>salarié ou travailleurs indépendants</li>
							<li>régime agricole</li>
							<li>régime des cultes et régime des professions libérales</li>
						</ul>
						<p className="mb-2">Il n’y a qu'une seule demande à faire pour l'ensemble des régimes de retraite, de base et complémentaire pour les régimes mentionnés ci-dessus.</p>
						<p className="mb-0">
							<b>Exemple: </b>
						</p>
						<p className="mb-0 small">MSA et Indépendant ={">"} 1 demande de fin de versement de pension ou réversion;</p>
						<p className="mb-2 small">MSA et fonctionnaire ={">"} demandes fin de versement de pension ou réversion</p>
					</article>
					<article className="block pb-lg" id="AIDES">
						<h2 className="text-uppercase font-weight-demi mt-4">Je ne sais pas quelles aides demander ?</h2>
						<p className="mb-0">Pour visualiser votre éligibilité aux aides, passez votre souris au-dessus de chacune d’entre elles, un texte apparaîtra avec les conditions pour les obtenir. </p>
					</article>
					<article className="block pb-lg" id="REVERSIONS">
						<h2 className="text-uppercase font-weight-demi mt-4">Pourquoi dois-je choisir les réversions ?</h2>
						<p className="mb-0">Vous devez sélectionner la réversion de base et complémentaire ainsi que les autres reversions possible ancien combattant … si proposé, éligible..</p>
					</article>
					<article className="block pb-lg" id="DELAIS">
						<h2 className="text-uppercase font-weight-demi mt-4">Les courriers sont générés, mais je ne connais pas les délais à respecter pour l’envoi.</h2>
						<p className="mb-0">Tous les délais à respecter sont écrits sur le “tableau de bord” de votre espace. Les courriers sont triés par catégorie (à envoyer sous 7 jours, 30 jours, 6 mois).</p>
					</article>
					<article className="block pb-lg" id="ORGANISMES">
						<h2 className="text-uppercase font-weight-demi mt-4">Je ne trouve pas le courrier du service/organisme sélectionné. </h2>
						<p className="mb-0">Si vous avez plusieurs organismes par service (exemple: banque, retraite, assurance…), vous avez des onglets violets en haut à droite, quand vous cliquez sur le service vous accédez aux courriers souhaités.</p>
					</article>
					<article className="block pb-lg" id="MODIFICATION">
						<h2 className="text-uppercase font-weight-demi mt-4">Peut-on modifier les informations après la génération des courriers ?</h2>
						<p className="mb-0">Non, mais vous pouvez générer de nouveaux courriers . Rendez-vous sur l’organisme choisi, et cliquez sur “ajouter une autre référence” et entrez les informations. Cela créera automatiquement un nouveau courrier.</p>
					</article>
					<article className="block pb-lg" id="CREER-DOSSIER">
						<h2 className="text-uppercase font-weight-demi mt-4">Comment créer un dossier dans l’espace bibliothèque ayant droit? </h2>
						<p className="mb-0">Pour créer un dossier avec des documents, rendez-vous sur l’onglet “bibliothèque de documents” et cliquez sur “nouveau” et enfin “dossier”. Vous pouvez créer autant de dossiers que vous souhaitez.</p>
					</article>
					<article className="block pb-lg" id="TELECHARGER">
						<h2 className="text-uppercase font-weight-demi mt-4">Comment télécharger les documents de la bibliothèque de documents ?</h2>
						<p className="mb-0">Pour télécharger des documents de votre bibliothèque, rendez-vous sur le document et cliquez dessus. Une nouvelle fenêtre s’ouvre, vous pouvez télécharger ou imprimer le document.</p>
					</article>
					<article className="block pb-lg" id="PARTAGER">
						<h2 className="text-uppercase font-weight-demi mt-4">Peut-on partager un document ?</h2>
						<p className="mb-0">
							Oui, Pour partager un document de la bibliothèque, rendez-vous dans “la bibliothèque de document”, sélectionnez le document et cliquez sur le bouton “partager” en haut à droite. Il ne vous restera plus qu'à renseigner l’adresse mail du destinataire. Il recevra un mail avec le fichier zippé.{" "}
						</p>
					</article>
					<article className="block pb-lg" id="CONTACT">
						<h2 className="text-uppercase font-weight-demi mt-4">Vous ne trouvez pas la réponse à votre question ?</h2>
						<p className="mb-2">Faites une demande à votre responsable de plateau : </p>
						<ul className="pl-sm">
							<li>
								Mélodie Renoux :{" "}
								<a className="text-info btn-link font-weight-bold" target="blank" href="mailto:m.renoux@funecap.com">
									m.renoux@funecap.com
								</a>
							</li>
							<li>
								Clémence Guinot :{" "}
								<a className="text-info btn-link font-weight-bold" target="blank" href="mailto:c.guinot@funecap.com">
									c.guinot@funecap.com
								</a>
							</li>
							<li>
								Jérémy Coëffic :{" "}
								<a className="text-info btn-link font-weight-bold" target="blank" href="mailto:j.coeffic@funecap.com">
									j.coeffic@funecap.com
								</a>
							</li>
							<li>
								Jonathan Lavigne :{" "}
								<a className="text-info btn-link font-weight-bold" target="blank" href="mailto:j.lavigne@funecap.com">
									j.lavigne@funecap.com
								</a>
							</li>
							<li>
								Sylvie Santoni :{" "}
								<a className="text-info btn-link font-weight-bold" target="blank" href="mailto:s.santoni@funecap.com">
									s.santoni@funecap.com
								</a>
							</li>
						</ul>
					</article>
				</section>
			</div>
		</main>
	);
}